import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'
import MyMeetings from '@/components/MyMeetings'
import EditMeeting from '@/components/EditMeeting'
import ViewMeeting from '@/components/ViewMeeting'
import JoinMeeting from '@/components/JoinMeeting'
import Login from '@/components/login'
import Home from '@/components/Home'
import TOS from '@/components/landingPage/TOS'
import PrivacyPolicy from '@/components/landingPage/PrivacyPolicy'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/MyMeetings',
      name: 'MyMeetings',
      component: MyMeetings,
      meta: {
        requiresAuth: true,
        title: 'My Meetings'
      }
    },
    {
      path: '/editMeeting',
      name: 'EditMeeting',
      component: EditMeeting
    },
    {
      path: '/viewMeeting',
      name: 'ViewMeeting',
      component: ViewMeeting,
      meta: {title: 'View Meeting'}
    },
    {
      path: '/joinMeeting/*',
      name: 'JoinMeeting',
      component: JoinMeeting
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/tos',
      name: 'TOS',
      component: TOS
    },
    {
      path: '/privacypolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/home',
      name: 'Home',
      component:  Home
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: (to, from, next) => {
        const currentUser = firebase.auth().currentUser
        if (currentUser) {
          next('MyMeetings')
        } else {
          next()
        }
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = 'Moogenda - ' + to.meta.title
  }
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    if (!currentUser) {
      next('login')
    } else {
      next()
    }
  } else next()
})

export default router
